import { Variant } from "@/types/index";

/**
 * Validates if two variants have different skipass durations.
 * @param {Variant} variant1 - The first variant to check.
 * @param {Variant} variant2 - The second variant to check.
 * @returns {boolean} True if variants have different skipass durations, false otherwise.
 */
const hasDifferentSkipassDuration = (variant1: Variant, variant2: Variant): boolean => {
  return variant1.skipass !== variant2.skipass;
};

/**
 * Determines if the combination of variants has different skipass durations.
 * This will prevent selecting any different skipass durations together (2/3, 5/6, 6/7, 7/8, etc.)
 * @param {Variant[]} variants - An array of variants to check.
 * @returns {boolean} True if any variants have different skipass durations, false otherwise.
 */
export const isValidNewSkiPassPackages = (variants: Variant[]): boolean => {
  if (!variants || variants.length < 2) return false;

  for (let i = 0; i < variants.length; i++) {
    for (let j = i + 1; j < variants.length; j++) {
      // If variants have different skipass durations
      if (hasDifferentSkipassDuration(variants[i], variants[j])) {
        return true; // Return true if we find any different skipass durations
      }
    }
  }

  return false;
};